export default "__VITE_ASSET__q740bdBP__"